export let hrms76xColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRMS76X1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRMS76X1',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codpos',
    name: '',
    labelCodapp: 'HRMS76X1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'numlvl',
    name: '',
    labelCodapp: 'HRMS76X1',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRMS76X1',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codtparg',
    name: '',
    labelCodapp: 'HRMS76X1',
    labelIndex: '100',
    style: 'min-width: 150px;'
  }, {
    key: 'codplan',
    name: '',
    labelCodapp: 'HRMS76X1',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_staappr',
    name: '',
    labelCodapp: 'HRMS76X1',
    labelIndex: '120',
    style: 'min-width: 200px;'
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms76x.js